import { useEffect, useState } from 'react';
import { AiOutlineClose } from 'react-icons/ai';
import { useNavigate } from 'react-router-dom';

import {
  HealthMachineDetailStyled,
  HealthMachineDetailStyleProps,
} from './styled';

import clsx from 'clsx';
import { ref, set } from 'firebase/database';
import { useFormik } from 'formik';
import healthList from 'src/apis/samples/health';
import Button from 'src/components/Button';
import database from 'src/libraries/firebase';

interface HealthMachineDetailProps extends HealthMachineDetailStyleProps {
  className?: string;
  healthId?: number;
  onClose: () => void;
}

const HealthMachineDetail = ({
  healthId,
  className,
  onClose,
  ...props
}: HealthMachineDetailProps) => {
  const navigate = useNavigate();
  const activeHealth = healthList.find(health => health.id === healthId);
  const [saveActiveHealth, setSaveActiveHealth] = useState<any>(null);
  const robotSettingRef = ref(database, 'health_robot/setting');
  const formik = useFormik({
    initialValues: {
      sett: 3,
      count: 10,
    },
    onSubmit: async values => {
      await set(robotSettingRef, {
        goal_count: values.count,
        goal_set: values.sett,
        health_kind: healthId,
        status: 'MOVING',
      });
      navigate(`/motioning/${healthId}`);
    },
  });

  useEffect(() => {
    if (activeHealth) {
      setSaveActiveHealth(activeHealth);
    }
  }, [activeHealth]);

  return (
    <HealthMachineDetailStyled
      className={clsx('HealthMachineDetail', className)}
      {...props}
    >
      <div className="image">
        <button
          className="close-button"
          onClick={() => {
            onClose();
          }}
        >
          <AiOutlineClose />
        </button>
        <img src={saveActiveHealth?.image} alt={saveActiveHealth?.title} />
      </div>
      <div className="content">
        <h2 className="title">{saveActiveHealth?.title}</h2>
        <div className="description">{saveActiveHealth?.description}</div>

        <div className="action-button">
          <div className="health-form">
            <div className="form-wrap">
              <div className="input">
                <input
                  type="number"
                  className="health-form-input"
                  name="sett"
                  value={formik.values.sett}
                  onChange={formik.handleChange}
                />
              </div>
              <div className="label">세트</div>
            </div>
            <div className="form-wrap">
              <div className="input">
                <input
                  type="number"
                  className="health-form-input"
                  name="count"
                  value={formik.values.count}
                  onChange={formik.handleChange}
                />
              </div>
              <div className="label">회</div>
            </div>
          </div>
          <Button
            block
            onClick={() => {
              formik.handleSubmit();
            }}
          >
            시작하기
          </Button>
          <Button
            color="#ededed"
            textColor="#000"
            block
            onClick={() => {
              onClose();
            }}
          >
            뒤로가기
          </Button>
        </div>
      </div>
    </HealthMachineDetailStyled>
  );
};

export default HealthMachineDetail;
